export default "__VITE_PUBLIC_ASSET__845e6ae5__"